import React from 'react';
import { NavLink } from 'react-router-dom';
import styles from './AccountSubmenu.module.scss';

type Props = {
  links: any[];
};

const AccountSubmenu = ({ links }: Props) => (
  <div className={styles.wrapper}>
    <div className={styles.container}>
      <div className={styles.linksWrapper}>
        {(links || []).map((link: any, index: number) =>
        
          <NavLink
            key={index}
            to={link.url || ""}
            className={styles.link}
            activeClassName={styles.active}
          >
            {link.name}
          </NavLink>
        )}
      </div>
    </div>
  </div>
);

export default AccountSubmenu;
